<template>

    <div>
        <div class="layui-card-header">
            <blockquote class="layui-elem-quote">
                认定说明
            </blockquote>
        </div>

        <div class="layui-card-body">
            <!-- <img class="rdsmimg" style="width: 80%;margin-left: 10%" src="../../../static/img/sblc.png"> -->
        </div>
    </div>
</template>

<script>
    export default {
        name: 'app',
        compoents: {

        },
        data() {
            return {

            }
        },
        created() {
        },
        mounted() {

        }
    }
</script>

<style scoped>
    .layui-card-body {
        position: relative;
        padding: 10px 15px;
        line-height: 24px;
    }

    .layui-card-header {
        position: relative;
        height: 42px;
        line-height: 42px;
        padding: 0 15px;
        border-bottom: 1px solid #f6f6f6;
        color: #333;
        border-radius: 2px 2px 0 0;
        font-size: 14px;
    }

    .layui-elem-quote {
        margin-bottom: 10px;
        padding: 15px;
        line-height: 22px;
        border-left: 5px solid #009688;
        border-radius: 0 2px 2px 0;
        background-color: #f2f2f2;
    }
</style>



// WEBPACK FOOTER //
// src/components/affirm/affirmExplain.vue